export const DOMAIN_PREFIX_TO_CLOUD_COOKIE_NAME_SUFFIX = new Map([
  [ 'id-alpha', 'alp' ],
  [ 'id-preprod', 'stg' ],
  [ 'account', 'prd' ],
  [ 'local', 'local' ],
]);
